/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BuyerRepresentation = {
    Agent: 'agent',
    Self: 'self',
    Unrepresented: 'unrepresented'
} as const;
export type BuyerRepresentation = typeof BuyerRepresentation[keyof typeof BuyerRepresentation];


export function BuyerRepresentationFromJSON(json: any): BuyerRepresentation {
    return BuyerRepresentationFromJSONTyped(json, false);
}

export function BuyerRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuyerRepresentation {
    return json as BuyerRepresentation;
}

export function BuyerRepresentationToJSON(value?: BuyerRepresentation | null): any {
    return value as any;
}

